var map = {
	"./thumbnail-0.jpg": "0Z6L",
	"./thumbnail-1.jpg": "03AS",
	"./thumbnail-2.jpg": "V6WZ",
	"./thumbnail-3.jpg": "6eA4",
	"./thumbnail-4.jpg": "AMpf",
	"./thumbnail-5.jpg": "HfXz",
	"./thumbnail-6.jpg": "VF43",
	"./thumbnail-7.jpg": "VhbN",
	"./thumbnail-8.jpg": "N6hP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DOIM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/thumbnail\-.*\.jpg$
// module id = DOIM
// module chunks = 1